import { apiRequest, withToken } from './http-client';

export const groupCreate = async (token, data) => {
    return apiRequest({
        method: 'post',
        url: '/group/',
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getGroup = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/group/',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const getGroupById = async (token, groupId, params = {}) => {
    return apiRequest({
        method: 'get',
        url: `/group/${groupId}`,
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const searchGroup = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/group/search',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const getGroupUsers = async (token) => {
    return apiRequest({
        method: 'get',
        url: '/group/users',
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const updateGroup = async (token, groupId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/group/${groupId}`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const deleteGroup = async (token, groupId) => {
    return apiRequest({
        method: 'delete',
        url: `/group/${groupId}`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};
